const secrets = new Map<string, string>();
export function isExamGuestPath() {
  return /^\/exam-(access|status|portal)(\/|$)/.test(window.location.pathname);
}
export function captureExamFragment(): string {
  if (!isExamGuestPath()) return '';
  const path = window.location.pathname;
  const token = new URLSearchParams(window.location.hash.slice(1)).get('token');
  if (window.location.hash)
    window.history.replaceState(
      window.history.state,
      '',
      window.location.pathname + window.location.search,
    );
  if (token) secrets.set(path, token);
  return secrets.get(path) ?? '';
}
export function forgetExamFragment() {
  secrets.delete(window.location.pathname);
}
export function protectGuestDocument() {
  captureExamFragment();
  document.title = 'TED · Exams';
  for (const [name, content] of [
    ['robots', 'noindex,nofollow'],
    ['referrer', 'no-referrer'],
  ]) {
    let meta = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = name!;
      document.head.append(meta);
    }
    meta.content = content!;
  }
}
